export default function () {
  this.loadSettings()
}
